import Button from "../../../../componentes/button/button";
import AcaoButtons from "../../Shared/AcaoButtons";

/**
 * Etapa de aprovação simples (Exemplo etapa 2, Compras etapa 4). Quem vai receber a próxima etapa
 * — inclusive quando é preciso escolher um usuário de um grupo — é decidido no Sidebar de
 * encaminhamento (acionado por onExecutarAcao), não aqui: este componente só cuida da ação em si.
 */
export default function EtapaAprovacaoComEscolha({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const podeAprovar = acoes.includes("APROVAR");
    const outrasAcoes = acoes.filter(a => a !== "APROVAR");

    return (
        <div className="flex flex-col gap-4">
            <div className="flex justify-end gap-2 flex-wrap">
                <AcaoButtons acoes={outrasAcoes} acaoEmExecucao={acaoEmExecucao} onAcao={onExecutarAcao} />
                {podeAprovar && (
                    <Button
                        variant="green"
                        label="Aprovar"
                        iconLeft="fa fa-check-circle"
                        loading={acaoEmExecucao === "APROVAR"}
                        onClick={() => onExecutarAcao("APROVAR", {})}
                    />
                )}
            </div>
        </div>
    );
}
